"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerToggle = exports.ToggleSpan = exports.DrawerToggleContainer = void 0;
var react_1 = __importDefault(require("react"));
var Icon_1 = require("../Common/Icon");
var styled_components_1 = __importDefault(require("styled-components"));
exports.DrawerToggleContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tpadding: 5px 8px;\n\tmax-width: 28px;\n\n\t", "\n\n\tspan {\n\t\tmargin-left: 2px;\n\t\t.tws-i-icon {\n\t\t\tbottom: 1px;\n\t\t\tfont-size: 9px !important;\n\t\t\tposition: relative;\n\t\t}\n\t}\n"], ["\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tpadding: 5px 8px;\n\tmax-width: 28px;\n\n\t", "\n\n\tspan {\n\t\tmargin-left: 2px;\n\t\t.tws-i-icon {\n\t\t\tbottom: 1px;\n\t\t\tfont-size: 9px !important;\n\t\t\tposition: relative;\n\t\t}\n\t}\n"])), function (props) {
    return props.isActive
        ? "\n\t\tbackground-color: #0080A5;\n\t\tborder-radius: 5px;\n\t\tcolor: #FFF;\n\t\t"
        : '';
});
exports.DrawerToggleContainer.displayName = 'DrawerToggleContainer';
exports.ToggleSpan = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tvertical-align: top;\n"], ["\n\tvertical-align: top;\n"])));
exports.ToggleSpan.displayName = 'ToggleSpan';
var DrawerToggle = function (props) {
    var open = props.open, OnToggle = props.OnToggle;
    return (react_1.default.createElement(exports.DrawerToggleContainer, { "data-testid": 'tws-drawer-toggle', isActive: open, onClick: OnToggle },
        react_1.default.createElement(exports.ToggleSpan, { title: open ? 'open' : 'closed' },
            react_1.default.createElement(Icon_1.Icon, { name: open ? 'angle-up' : 'angle-down' }))));
};
exports.DrawerToggle = DrawerToggle;
exports.default = exports.DrawerToggle;
var templateObject_1, templateObject_2;
